var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.showDetail
        ? _c("detail-list", {
            attrs: {
              "regions-list": _vm.regionsList,
              "responsibility-type-list":
                _vm.responsibilityTypeList.responsibility_type,
              "route-info": _vm.detailRouteInfo,
              "status-options": _vm.statusOptions,
            },
            on: {
              close: function ($event) {
                _vm.showDetail = false
              },
            },
          })
        : [
            _c(
              "el-card",
              { staticClass: "search-card", attrs: { shadow: "never" } },
              [
                _c(
                  "el-form",
                  { attrs: { model: _vm.queryParams, size: "small" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 15 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("base.billingMonth") } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "fixDutyFine.pleaseSelect"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.queryParams.reconciliationPeriod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParams,
                                          "reconciliationPeriod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryParams.reconciliationPeriod",
                                    },
                                  },
                                  _vm._l(
                                    _vm.accessiblePeriodList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: { label: item, value: item },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("fixDutyFine.region") },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "fixDutyFine.pleaseSelect"
                                      ),
                                    },
                                    model: {
                                      value: _vm.queryParams.regionId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParams,
                                          "regionId",
                                          $$v
                                        )
                                      },
                                      expression: "queryParams.regionId",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("fixDutyFine.allRegions"),
                                        value: null,
                                      },
                                    }),
                                    _vm._l(_vm.regionsList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: _vm.getRegionName(item),
                                          value: item.id,
                                        },
                                      })
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("fixDutyFine.penaltyType"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.tudo"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value: _vm.queryParams.responsibilityType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParams,
                                          "responsibilityType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryParams.responsibilityType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.responsibilityTypeList
                                      .responsibility_type,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("fixDutyFine.processStatus"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "fixDutyFine.pleaseSelect"
                                      ),
                                    },
                                    model: {
                                      value: _vm.queryParams.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParams, "status", $$v)
                                      },
                                      expression: "queryParams.status",
                                    },
                                  },
                                  _vm._l(_vm.statusOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 15 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("fixDutyFine.waybillNumber"),
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "fixDutyFine.waybillPlaceholder"
                                    ),
                                    rows: 1,
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.queryParams.waybillNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "waybillNumber",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.waybillNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "margin-top": "29px" },
                            attrs: { span: 18 },
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      icon: "el-icon-search",
                                      type: "primary",
                                    },
                                    on: { click: _vm.handleQuery },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("fixDutyFine.query")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { icon: "el-icon-refresh" },
                                    on: { click: _vm.resetQuery },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("fixDutyFine.reset")) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "overview-row" },
              _vm._l(_vm.overviewCards, function (card, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "overview-card",
                    class: "card-" + card.type,
                  },
                  [
                    _c("div", { staticClass: "card-header" }, [
                      _c("span", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(card.title)),
                      ]),
                      _c("i", { staticClass: "card-icon", class: card.icon }),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(_vm._s(card.value)),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "card-sub",
                        class: {
                          "text-green": card.isGrowth,
                          "text-red": !card.isGrowth,
                          "text-orange": card.isWarning,
                        },
                      },
                      [
                        card.subIcon
                          ? _c("i", { class: card.subIcon })
                          : _vm._e(),
                        _vm._v(" " + _vm._s(card.sub) + " "),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "el-card",
              { staticClass: "table-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "table-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("fixDutyFine.regionPenaltySummary"))
                      ),
                    ]),
                    _c("span", { staticClass: "table-sub-title" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.summaryTip"))),
                    ]),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": {
                        background: "#f5f7fa",
                        color: "#606266",
                        fontWeight: "bold",
                      },
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("base.billingMonth"),
                        align: "left",
                        prop: "reconciliationPeriod",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.region"),
                        align: "left",
                        prop: "zhName",
                        width: "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "bold-text" }, [
                                _vm._v(_vm._s(_vm.getRegionName(scope.row))),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.confirmedLost"),
                        align: "center",
                        prop: "confirmedLostCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "confirmLoss"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.confirmedLostCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.StolenOrRobbed"),
                        align: "center",
                        prop: "stolenOrRobbedCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "preCheck"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.stolenOrRobbedCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.Damage"),
                        align: "center",
                        prop: "damagedCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "batter"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(scope.row.damagedCount)
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.timeoutNoClosure"),
                        align: "center",
                        prop: "timeoutNoClosureCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "overdue"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.timeoutNoClosureCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.complaintWorkOrder"),
                        align: "center",
                        prop: "complaintWorkOrderCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "complaint"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.complaintWorkOrderCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "fixDutyFine.SocialMediaUpgradeComplaint"
                        ),
                        align: "center",
                        prop: "socialMediaCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "escalation"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.socialMediaCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.timeoutReturn"),
                        align: "center",
                        prop: "timeoutReturnCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "clickable-text green-bold",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDrillDown(
                                        scope.row,
                                        "timeout"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.timeoutReturnCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.acceptedAmount"),
                        align: "right",
                        prop: "acceptedAmount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(scope.row.acceptedAmount)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.pending"),
                        align: "center",
                        prop: "pendingCount",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "pending-pill" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(scope.row.pendingCount)
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("fixDutyFine.ticketsUnit"))
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("fixDutyFine.completionRate"),
                        align: "center",
                        prop: "completionRate",
                        width: "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "progress-cell" },
                                [
                                  _c("el-progress", {
                                    attrs: {
                                      color:
                                        scope.row.completionRate >= 80
                                          ? "#67c23a"
                                          : "#e6a23c",
                                      percentage: scope.row.completionRate,
                                      "show-text": false,
                                      "stroke-width": 8,
                                    },
                                  }),
                                  _c("span", { staticClass: "progress-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.completionRate.toFixed(1)
                                      ) + "%"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }